import { useState } from "react";
import * as Tooltip from "@radix-ui/react-tooltip";
import { FaCopy } from "react-icons/fa";
import usePublicUserOrganization from "../CollaboratorHeader/hooks/usePublicUserOrganization";
import FullLoading from "../../../../../../components/FullLoading";
import { formatDate } from "../../../../../../lib/utils";

export default function CollaboratorInformations({
  userOrganizationId,
}: {
  userOrganizationId?: string;
}) {
  const [showTooltip, setShowTooltip] = useState<string | null>(null);

  const {
    data: publicUserOrganization,
    loading: publicUserOrganizationLoading,
  } = usePublicUserOrganization(userOrganizationId);

  const handleCopy = (label: string, value: string) => {
    navigator.clipboard.writeText(value);
    setShowTooltip(label);
    setTimeout(() => setShowTooltip(null), 1000);
  };

  const infoItem = (label: string, value: string | null | undefined) => {
    if (!value) return null;

    return (
      <div className="text-sm text-secondary flex items-center gap-2">
        <span className="text-primary font-bold ">{label}:</span>{" "}
        <Tooltip.Provider>
          <Tooltip.Root open={showTooltip === label}>
            <Tooltip.Trigger asChild>
              <div
                className="text-secondary cursor-pointer hover:text-primary transition-all duration-300 flex items-center gap-2"
                onClick={() => handleCopy(label, value)}
              >
                {value}
                <FaCopy className="w-3 h-3" />
              </div>
            </Tooltip.Trigger>
            <Tooltip.Portal>
              <Tooltip.Content
                className="rounded-md bg-black px-4 py-2 text-sm text-white"
                sideOffset={5}
              >
                Copié
                <Tooltip.Arrow className="fill-black" />
              </Tooltip.Content>
            </Tooltip.Portal>
          </Tooltip.Root>
        </Tooltip.Provider>
      </div>
    );
  };

  if (publicUserOrganizationLoading) {
    return <FullLoading />;
  }

  if (!publicUserOrganization) {
    return (
      <div className="text-secondary text-sm">Pas d'informations trouvées</div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      {publicUserOrganization.organizationName !== publicUserOrganization.name
        ? infoItem(
            "Nom de l'organisation",
            publicUserOrganization.organizationName
          )
        : null}

      {infoItem("Email", publicUserOrganization.email)}

      {infoItem("Téléphone", publicUserOrganization.phoneNumber)}

      {infoItem("Fonction", publicUserOrganization.jobTitle)}

      {infoItem(
        "Date de naissance",
        formatDate(publicUserOrganization.birthDate)
      )}
    </div>
  );
}
